import { Controller } from "@hotwired/stimulus"

// 작업환경측정 결과 — 측정값 / 기준값 % 자동 계산.
// 각 측정값 input 의 data-threshold 속성으로 분모를 가져와 같은 행의
// data-measurement-calc-target="twaRatio" / "stelRatio" 셀을 갱신.
export default class extends Controller {
  recalc(event) {
    const input = event.target
    if (!input || !input.dataset) return

    const targetName = input.dataset.measurementCalcTarget
    const ratioName = targetName === "twaValue" ? "twaRatio" : "stelRatio"
    const ratioCell = input.closest("tr")?.querySelector(`[data-measurement-calc-target="${ratioName}"]`)
    if (!ratioCell) return

    const value = parseFloat(input.value)
    const threshold = parseFloat(input.dataset.threshold)
    if (isNaN(value) || isNaN(threshold) || threshold === 0) {
      ratioCell.textContent = "-"
      ratioCell.classList.remove("text-red-600", "font-semibold")
      return
    }

    const ratio = (value / threshold) * 100
    ratioCell.textContent = `${ratio.toFixed(1)}%`
    // 100% 이상이면 강조 (노출기준 초과)
    if (ratio >= 100) {
      ratioCell.classList.add("text-red-600", "font-semibold")
    } else {
      ratioCell.classList.remove("text-red-600", "font-semibold")
    }
  }
}
